import {deepCopy} from "./controllerAdapterForOfferPage";

export const INTERNAL_MANUFACTURER_KEY = 'internal_product_manufacturer_id';
export const USER_MANUFACTURER_KEY = 'user_manufacturer_id';

export const getAllManufacturersList = (
  manufacturerRecommendationForProject,
  allManufacturerDiscountForProject,
  searchQuery = "",
  filterFn = null
) => {
  searchQuery = typeof searchQuery === 'string' ? searchQuery.toLowerCase().trim() : '';
  let results = [];

  if (
      !Array.isArray(manufacturerRecommendationForProject) &&
      typeof manufacturerRecommendationForProject === "object" &&
      manufacturerRecommendationForProject
  ) {
    manufacturerRecommendationForProject = Object.values(manufacturerRecommendationForProject);
  }

  results = manufacturerRecommendationForProject

  if (Array.isArray(allManufacturerDiscountForProject.internal_manufacturer_discount)) {
    results = results.concat(allManufacturerDiscountForProject.internal_manufacturer_discount);
  }

  if (Array.isArray(allManufacturerDiscountForProject.user_manufacturer_discount)) {
    results = results.concat(allManufacturerDiscountForProject.user_manufacturer_discount);
  }

  results = results.filter(x => {
    if (!searchQuery) { return true; }
    const xName = x.manufacturer_name.toLowerCase().trim();
    return xName.indexOf(searchQuery) !== -1;
  });

  if (typeof filterFn === "function") {
    results = results.filter(filterFn);
  }

  const internals = deepCopy(results.filter(x => INTERNAL_MANUFACTURER_KEY in x));
  const customs = deepCopy(results.filter(x => USER_MANUFACTURER_KEY in x));
  internals.sort((a, b) => a.manufacturer_name.localeCompare(b.manufacturer_name));
  customs.sort((a, b) => a.manufacturer_name.localeCompare(b.manufacturer_name));

  internals.forEach(x => x[INTERNAL_MANUFACTURER_KEY] = +x[INTERNAL_MANUFACTURER_KEY]);
  customs.forEach(x => x[USER_MANUFACTURER_KEY] = +x[USER_MANUFACTURER_KEY]);

  const fullList = internals.concat(customs);
  fullList.forEach(x => x.discount = +x.discount || 0);

  return fullList
}

export function setAutoManufacturer(jqInput, manufacturerObj) {
  jqInput.val(manufacturerObj.manufacturer_name);
  jqInput.prop('disabled', true);
  jqInput.closest('.twitter-typeahead')
  .append('<i class="fa fa-times-circle manu-cancel"></i>')

  if (INTERNAL_MANUFACTURER_KEY in manufacturerObj) {
    jqInput.attr('data-ipmi', manufacturerObj[INTERNAL_MANUFACTURER_KEY]);
  }
  else if (USER_MANUFACTURER_KEY in manufacturerObj) {
    jqInput.attr('data-umi', manufacturerObj[USER_MANUFACTURER_KEY]);
  }
}